import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ressourcesModules } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ressourcesModules],
    selector: 'app-chart-layout',
    templateUrl: './chart-layout.component.html',
})
export class ChartLayoutComponent {
    public readonly isStatisticScreen = input<boolean>(true);
    public readonly isTitleCentred = input<boolean>(false);
    public readonly subtitle = input<string>('');
    public readonly title = input<string>('');
}
